import type React from 'react'

interface FlagIconProps {
  size?: number | string
  color?: string
  className?: string
}

const FlagIcon: React.FC<FlagIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Flag Icon'}
      role="img"
    >
      <path
        d="M5.69922 22V2C5.69922 1.58579 6.03501 1.25 6.44922 1.25C6.86343 1.25 7.19922 1.58579 7.19922 2V22C7.19922 22.4142 6.86343 22.75 6.44922 22.75C6.03501 22.75 5.69922 22.4142 5.69922 22Z"
        fill={color}
      />
      <path
        opacity="0.34"
        d="M6.26111 3.70235C6.42551 3.32233 6.8673 3.14747 7.24744 3.31172L15.347 6.81172H15.3461C17.0798 7.54814 18.2625 8.67954 18.2992 10.1057C18.3355 11.5226 17.2242 12.7248 15.5931 13.5666L15.5814 13.5725L7.28162 17.6731C6.9103 17.8563 6.46014 17.7035 6.27673 17.3322C6.09349 16.9609 6.24627 16.5108 6.61755 16.3273L14.9066 12.2326C16.3743 11.4748 16.8137 10.6776 16.8002 10.1447C16.7868 9.62203 16.3204 8.8542 14.7562 8.19063L14.7523 8.18868L6.65173 4.68868C6.27171 4.52427 6.09685 4.08248 6.26111 3.70235Z"
        fill={color}
      />
    </svg>
  )
}

export default FlagIcon
